import React, { useEffect, useRef } from "react";
import { FormControl, FormLabel, Grid, TextField } from "@material-ui/core";
import { useForm } from "hooks/useForm";
import { fieldValidations, initialValues } from "./inputValues";
import RegularButton from "components/CustomButtons/Button";
import { useDispatch, useSelector } from "react-redux";
import { verifyIp } from "helpers/verifyIp";
import { useSearch } from "hooks/useSearch";
import { Autocomplete } from "@material-ui/lab";
import { editPrinter, registerNewPrinter } from "redux/actions/printers/printersActions";

export const PrinterForm = ({ isEdit, printer, onClose }) => {
  const dispatch = useDispatch();
  const { stationsList, stations } = useSelector(({ companies }) => companies);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const {
    inputValues,
    handleInputOnChange,
    cleanForm,
    runValidates,
    handleNewValues,
    fieldErrors,
  } = useForm(initialValues, fieldValidations);
  const { setSnackbar } = useSearch()
  // const [autoFocus, setAutoFocus] = useState(true)
  const { name, idStation, ip } = inputValues;
  const ref = useRef()
  const handleSubmit = (e) => {
    e.preventDefault();
    if(verifyIp(ip)) return setSnackbar("La dirección IP no es válida", 'warning')
    if (runValidates()) return;
    let form = {
      ip: ip,
      name: name,
      idStation: idStation.id
    }
    if(isEdit){
      dispatch(editPrinter(printer.id, form))
      onClose()
    } else {
      dispatch(registerNewPrinter(form));
      cleanForm();
    }
    // setAutoFocus(true)
    if (ref.current) {
      ref.current.focus();
    }
  };

  const handleChange = (e, v) => {
    const value = v ? v : ''
    handleNewValues({
      idStation: value,
    })
  }
  useEffect(() => {
    isEdit && handleNewValues({
      ...printer,
      idStation: stations[printer?.idStation]
    });
  }, []);

  return (
    <FormControl fullWidth>
      <FormLabel>{/* Nombre Formulario  */}</FormLabel>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Nombre"
            name="name"
            value={name}
            variant="outlined"
            fullWidth
            size="small"
            required={true}
            error={fieldErrors?.name}
            helperText={fieldErrors?.name || ""}
            onChange={handleInputOnChange}
            // autoFocus={autoFocus}
            // inputRef={ref}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            label="Dirección_IP"
            name="ip"
            value={ip}
            variant="outlined"
            fullWidth
            size="small"
            required={true}
            error={fieldErrors.ip}
            helperText={fieldErrors.ip || ""}
            onChange={handleInputOnChange}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <Autocomplete
              id="printer-autoselect"
              options={stationsList}
              value={idStation}
              getOptionLabel={(option) =>
                option.label ? option.label : option.name || ''
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Planta"
                  variant="outlined"
                  size="small"
                />
              )}
              fullWidth
              onChange={(e, v) => handleChange(e, v)}
              noOptionsText="No se encuentra la planta"
            />
        </Grid>

        <Grid item xs={12}>
          <RegularButton
            size="sm"
            color="info"
            tooltip="Aceptar"
            onClick={handleSubmit}
            fullWidth
            disabled={isLoadingComp?.loadingFormPrinter}
          >
            {isEdit ? "Editar" : "Agregar"}
          </RegularButton>
        </Grid>
      </Grid>
    </FormControl>
  );
};
